import styled from "styled-components";

import breakpoints from "../../styles/breakpoints";

import { Section } from "../../components/atoms/Section";
import Link from "../../components/atoms/LinkWineScreen";
import { colors, fonts } from "../../styles/variables";

export const StyledWinesSection = styled(Section)`
  padding-top: 0px !important;
`;

export const ContainerTop = styled.div`
  width: 100%;
  display: flex;
  padding-right: 15px;
  justify-content: space-between;
  ${breakpoints.smDown} {
    flex-direction: column;
    padding-right: 0;
  }
`;

export const SmUpSearchContainer = styled.div`
  ${breakpoints.smDown} {
    display: none;
  }
`;

export const SearchAndFilterResultsContainer = styled.div`
  margin-bottom: 20px;
  background-color: ${colors.peach};
  ${breakpoints.smUp} {
    display: none;
  }
`;

export const SearchAndFilterResultsInnerContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0px;
`;

export const SearchResultsLabel = styled.p`
  margin-bottom: 0px;
`;

export const ClearAll = styled.p`
  font-family: ${fonts.fontBauMedium};
  font-size: 12px;
  cursor: pointer;
`;

export const OptionsButtons = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  width: 50%;

  ${breakpoints.smDown} {
    justify-content: center;
    /* Support for iOS Safari <= 10 using fit-content over 100% value */
    height: fit-content;
    width: 100%;
    padding-right: 25px;
  }
`;

export const OptionButton = styled(Link)<{
  selected: boolean;
}>`
  width: 50%;
  ${breakpoints.smDown} {
    width: 60%;
    flex-direction: column;
  }
`;

export const FilterWinesWrapper = styled.div<{
  open?: boolean;
}>`
  width: 48%;
  max-width: 300px;
  padding-bottom: 20px;
  box-shadow: ${(props) => (props.open ? "0 10px 10px 0px rgba(0, 0, 0, 0.1)" : "")};
  ${breakpoints.smDown} {
    width: 100%;
    max-width: none;
  }
`;

export const ChooseFreeBottleFooter = styled.div`
  background-color: ${colors.warning};
  align-items: flex-start;
  justify-content: center;
  position: sticky;
  left: 0;
  bottom: 0;
  display: block;
  z-index: 20;
`;

export const ChooseFreeBottleTitle = styled.p`
  position: relative;
  ${breakpoints.smUp} {
    font-size: 16px;
    padding: 15px 10px 15px 0px;
  }
  ${breakpoints.smDown} {
    font-size: 14px;
    padding: 10px 10px 10px 0px;
    height: 35px;
  }
  line-height: 16px;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateUltraBlack};
  letter-spacing: 1.4px;
  text-transform: uppercase;
`;

export const ChooseFreeBottleTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
`;
